import axios from 'axios'
import config from '../config'
import Qs from 'qs'

export default {
  getGlobal(data) {
    return axios.post(
      `${config.tplApiURL}/template/GetGlobal`,
      Qs.stringify(data)
    ) // 获取全局配置
  },
  getPage(data) {
    return axios.post(
      `${config.tplApiURL}/template/GetPage`,
      Qs.stringify(data)
    ) // 获取页面配置
  },
  // 首页登录
  login(data) {
    return axios.post(
      `${config.tplApiURL}/Visitor/LoginenByEmail`,
      Qs.stringify(data)
    ) // 获取input 配置项
  },
  getinput(data) {
    return axios.post(
      `${config.tplApiURL}/template/getinput`,
      Qs.stringify(data)
    ) // 获取input 配置项
  },

  getEFWapToken(data) {
    return axios.post(
      `${config.apiURL}/Visitor/GetEFWapToken`,
      Qs.stringify(data)
    ) // 获取token
  },
  // 手机查重
  PsnMobileRepeat(data) {
    return axios.post(
      `${config.apiURL}/Visitor/PsnMobileRepeat`,
      Qs.stringify(data)
    ) // 获取token
  },
  CheckPCCode(data) {
    return axios.post(
      `${config.apiURL}/visitor/CheckPCCode`,
      Qs.stringify(data)
    )
  },
  CheckEmailToRegisted(data) {
	  return axios.post(
	    `${config.apiURL}/visitor/CheckEmailToRegisted`,
	    Qs.stringify(data)
	  )
	},
	
  // 根据psjid获取已注册用户信息
  getRegistInfo(data) {
    return axios.post(
      `${config.apiURL}/visitor/GetRegistInfo`,
      Qs.stringify(data)
    )
  },

  // 根据手机号获取往届信息
  getPeronInfo(data) {
    return axios.post(
      `${config.apiURL}/visitor/GetENPeronInfo`,
      Qs.stringify(data)
    )
  },

  // 获取拼图Token
  getVerifyToken(data) {
    return axios.post(
      `${config.apiURL}/visitor/GetVerifyToken`,
      Qs.stringify(data)
    )
  },

  // 获取滑块验证码
  getVerificationCode(data) {
    return axios.post(
      `${config.apiURL}/visitor/GetVerificationCode`,
      Qs.stringify(data)
    )
  },
  // 忘记密码验证验证码
  CheckVerificationCodeF(data) {
    return axios.post(
      `${config.apiURL}/visitor/CheckVerificationCode`,
      Qs.stringify(data)
    )
  },
  // 修改密码
  UpdatePwd(data) {
    return axios.post(
      `${config.apiURL}/Visitor/UpdatePwd`,
      Qs.stringify(data)
    )
  },
  getCity(data) {
    return axios.post(`${config.apiURL}/visitor/GetCity`, Qs.stringify(data)) // 获取城市
  },

  getProvince(data) {
    return axios.post(
      `${config.apiURL}/visitor/GetProvince`,
      Qs.stringify(data)
    )
  },

  getCountry(data) {
    return axios.post(`${config.apiURL}/visitor/GetCountry`, Qs.stringify(data)) // 获取国家
  },

  // 邮箱查重ng
  emailRepeat(data) {
    return axios.post(
      `${config.apiURL}/visitor/EmailRepeat`,
      Qs.stringify(data)
    )
  },

  // 身份证号查重
  IDCardRepeat(data) {
    return axios.post(
      `${config.apiURL}/visitor/IDCardRepeat`,
      Qs.stringify(data)
    )
  },

  // 提交基本信息
  saveVisitor(data) {
    return axios.post(
      `${config.apiURL}/visitor/SaveVisitor`,
      Qs.stringify(data)
    )
  },
  // 协助注册
  updateVisitor(data) {
    return axios.post(
      `${config.apiURL}/PCVisitor/UpdateVisitor`,
      Qs.stringify(data)
    )
  },
  // 手机查重
  mobileRepeat(data) {
    return axios.post(
      `${config.apiURL}/visitor/PsnMobileRepeat`,
      Qs.stringify(data)
    )
  },

  // 获取问卷
  getQuestions(data) {
    return axios.post(`${config.apiURL}/visitor/GetAnswers`, Qs.stringify(data))
  },

  // 获取注册人员答案信息
  getUserAnswers(data) {
    return axios.post(
      `${config.apiURL}/PCVisitor/RegistAns`,
      Qs.stringify(data)
    )
  },

  // 提交问卷
  saveAns(data) {
    return axios.post(`${config.apiURL}/visitor/SaveAns`, Qs.stringify(data))
  },

  // 更新问卷
  updateAns(data) {
    return axios.post(
      `${config.apiURL}/PCVisitor/UpdateVisitorAns`,
      Qs.stringify(data)
    )
  },

  // // 下载邀请函
  getConfirmPdf(data) {
    return axios.post(
      `${config.apiURL}/visitor/GetConfirmPdf`,
      Qs.stringify(data)
    )
  },

  // 获取邀请函信息
  visitorStrategy(data) {
    return axios.post(
      `${config.apiURL}/PCVisitor/VisitorStrategy`,
      Qs.stringify(data)
    )
  },

  // 重置密码
  resetPasswrod(data) {
    return axios.post(`${config.apiURL}/Visitor/EditPwd`, Qs.stringify(data))
  },

  // 获取团组列表
  groupMembers(data) {
    return axios.post(
      `${config.apiURL}/PCVisitor/GroupMembers`,
      Qs.stringify(data)
    )
  },

  groupMembersExport(data) {
    return `${config.apiTestUrl}/PCVisitor/GroupMembersExport?exhid=${data.ExhID}&PsnID=${data.PsnID}&Language=cn`
  },

  // 提交团组注册
  groupRegist(data) {
    return axios.post(
      `${config.apiURL}/PCVisitor/GroupRegist`,
      Qs.stringify(data)
    )
  },
  // 获取协助注册列表
  assisedMembers(data) {
    return axios.post(
      `${config.apiURL}/PCVisitor/AssisedMembers`,
      Qs.stringify(data)
    )
  },
  // 邀请
  getInviteStrategy(data) {
    return axios.post(
      `${config.apiURL}/PCVisitor/GetInviteStrategy`,
      Qs.stringify(data)
    )
  },
  // 发送邮件
  sendInviteEmial(data) {
    return axios.post(
      `${config.apiURL}/PCVisitor/SendInviteEmial`,
      Qs.stringify(data)
    )
  },
  // 获取会议列表
  getActivityList(data) {
    return axios.post(
      `${config.apiURL}/Activity/GetActivityList`,
      Qs.stringify(data)
    )
  },
  // 提交会议
  saveActivity(data) {
    return axios.post(
      `${config.apiURL}/Activity/SaveActivity`,
      Qs.stringify(data)
    )
  },
  // 获取已报名的会议
  getPersonAty(data) {
    return axios.post(
      `${config.apiURL}/Activity/getPersonAty`,
      Qs.stringify(data)
    )
  },
  assisedMembersExport(data) {
    return `${config.apiTestUrl}/PCVisitor/AssisedMembersExport?exhid=${data.ExhID}&PsnID=${data.PsnID}&Language=en`
  },
  // 验证Token获取接口
  GetValidationToken(data) {
    return axios.post(
      `https://std.eastfair.com/IdCardAuthon/api/IdentityCheck/GetValidationToken`,
      Qs.stringify(data)
    )
  },
  // 验证身份证的真实性
  CheckValidation(data) {
    return axios.post(
      `https://std.eastfair.com/IdCardAuthon/api/IdentityCheck/CheckValidationv2`,
      Qs.stringify(data)
    )
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js